import { Quote, Star } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

const testimonials = [
  { name: "Sarah M.", role: "Handyman & Repairs · Charlotte, NC", text: "André replaced our flooring and fixed several things around the house. Punctual, tidy, and the quality was excellent. It truly felt like family taking care of our home." },
  { name: "James T.", role: "Residential Cleaning · Matthews, NC", text: "The cleaning team is fantastic — detailed and dependable. Our home has never looked better and they always leave everything spotless. Highly recommend C Duarte." },
  { name: "Priya R.", role: "Commercial Cleaning · Charlotte, NC", text: "We hired them for our office and couldn't be happier. Professional, thorough, and easy to schedule over WhatsApp. A trustworthy local business we'll keep using." },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-20 md:py-32 bg-graphite text-offwhite" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-12">
        <Reveal className="max-w-2xl mb-14 md:mb-16">
          <p className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-mustard mb-4">Testimonials</p>
          <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-tight">
            What our neighbors say.
          </h2>
          <p className="mt-4 text-offwhite/60 font-light">Trusted by families and businesses across the Charlotte area.</p>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((t, i) => (
            <Reveal key={i} delay={i * 0.1} className={i === 1 ? "md:mt-8" : ""}>
              <div
                className="h-full rounded-3xl bg-offwhite/[0.06] border border-offwhite/15 p-8 hover:border-mustard/40 transition-colors duration-500"
                data-testid={`testimonial-${i}`}
              >
                <Quote className="h-9 w-9 text-mustard mb-5" strokeWidth={1.5} />
                <div className="flex gap-1 mb-5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 text-mustard fill-mustard" />
                  ))}
                </div>
                <p className="text-offwhite/85 font-light leading-relaxed mb-8 italic">"{t.text}"</p>
                <div className="mt-auto">
                  <p className="font-display font-bold text-offwhite">{t.name}</p>
                  <p className="text-sm text-offwhite/50">{t.role}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
